var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("tr", [
    _c("td", [
      _c("div", { staticClass: "checkbox checkbox-primary" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.selected,
              expression: "selected",
            },
          ],
          staticClass: "styled",
          attrs: {
            disabled: !_vm.canManageTag,
            id: `tag-${_vm.tag.id}`,
            type: "checkbox",
          },
          domProps: {
            checked: Array.isArray(_vm.selected)
              ? _vm._i(_vm.selected, null) > -1
              : _vm.selected,
          },
          on: {
            change: function ($event) {
              var $$a = _vm.selected,
                $$el = $event.target,
                $$c = $$el.checked ? true : false
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 && (_vm.selected = $$a.concat([$$v]))
                } else {
                  $$i > -1 &&
                    (_vm.selected = $$a
                      .slice(0, $$i)
                      .concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.selected = $$c
              }
            },
          },
        }),
        _vm._v(" "),
        _c("label", { attrs: { for: `tag-${_vm.tag.id}` } }),
      ]),
    ]),
    _vm._v(" "),
    _c("td", { staticClass: "tag-name" }, [
      _c("label", { attrs: { for: `tag-${_vm.tag.id}` } }, [
        _vm._v(_vm._s(_vm.tag.name)),
        _vm.tag.group
          ? _c("span", { staticClass: "tag-group" }, [
              _vm._v(" - " + _vm._s(_vm.tag.group)),
            ])
          : _vm._e(),
      ]),
    ]),
    _vm._v(" "),
    _c("td", [_vm._v(_vm._s(_vm.tag.occurrences ? _vm.tag.occurrences : 0))]),
    _vm._v(" "),
    _c("td", [
      _vm.canManageTag
        ? _c(
            "a",
            {
              staticClass: "remove",
              attrs: { href: "" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.handleDeleteTag.apply(null, arguments)
                },
              },
            },
            [_c("i", { staticClass: "fa fa-minus-circle" })]
          )
        : _c("span", { staticClass: "disabled" }, [
            _c("i", { staticClass: "fa fa-minus-circle" }),
          ]),
    ]),
    _vm._v(" "),
    _vm.hasEdit
      ? _c(
          "td",
          [
            _vm.canManageTag
              ? _c(
                  "router-link",
                  {
                    staticClass: "manage-tag",
                    attrs: {
                      to: {
                        name: "system.tag",
                        params: { id: _vm.tag.id, tagType: _vm.tag.tag_type },
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "fa fa-fw fa-pencil-square-o" }),
                    _vm._v(" Edit\n    "),
                  ]
                )
              : _c("div", { staticClass: "disabled manage-tag" }, [
                  _c("i", { staticClass: "fa fa-fw fa-pencil-square-o" }),
                  _vm._v(" Edit\n    "),
                ]),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }